<template>
  <div class="login-style">
    <h1 class="login-title">营口房地产交易服务平台</h1>
    <div class="form-style">
      <h2>用户登录</h2>
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item prop="type">
          <el-radio-group v-model="form.type">
            <el-radio-button label="1">经纪人用户登录</el-radio-button>
            <el-radio-button label="2">普通用户登录</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          class="border-setyle"
          prop="user"
          label="用户"
          label-width="60px"
        >
          <el-input
            v-model="form.user"
            :placeholder="form.type == 1 ? '请输入经纪人账号' : '请输入用户名'"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="border-setyle"
          prop="psd"
          label="密码"
          label-width="60px"
        >
          <el-input
            v-model="form.psd"
            type="password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button style="width: 100%" type="primary" @click="login"
            >登录</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="text" @click="forgetPassWord"
            >忘记密码？</el-button
          >
          <span class="register-btn" v-if="form.type == 2">
            还未注册？
            <el-button size="small" type="text" @click="goRegister"
              >去注册</el-button
            >
          </span>
        </el-form-item>
      </el-form>
    </div>
    <div class="foot-style">
      <div class="foot-cont">
        <div>
          <p>
            <span>电话：0417-3581115 / 0417-3851115</span>
            <span>地址：新联北大街99号</span>
            <span>邮箱：ykdcxxkj@163.com</span>
          </p>
          <p class="xx-bottom">
            <span> 服务支持单位：营口市自然资源事务中心</span>
            <span>主办单位：营口大成信息科技咨询有限公司</span>
            <span>技术支持：营口大成信息科技咨询有限公司</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        type: 2,
        user: "",
        psd: "",
      },
      rules: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        psd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 3, message: "密码不得低于3个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    login() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var that = this;
          that
            .axios({
              method: "post",
              url: "/api/login/login.do",
              data: that.form,
            })
            .then(function (res) {
              console.log(res.data);
              if (res.data.status == 200) {
                localStorage.setItem("userId", res.data.data.userId);
                localStorage.setItem("userName", res.data.data.userName);
                res.data.data.type = that.form.type;
                that.$store.commit("setUserData", res.data.data);
                that.$router.push("/");
                // that.$message.success(res.data.msg);
              } else {
                that.$message.error(res.data.msg);
              }
            });
        }
      });
    },
    goRegister() {
      this.$router.push("/register");
    },
    forgetPassWord() {
      this.$router.push("/forgetPassWord");
    },
  },
};
</script>

<style lang="less">
.login-style {
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: url("../assets/login_bg1.jpg");
  background-size: 100%;
  background-repeat: no-repeat;
  .login-title {
    color: #fff;
    margin: 40px 0 0 60px;
    font-size: 34px;
    font-weight: normal;
  }
  .form-style {
    right: 110px;
    padding: 20px;
    width: 468px;
    height: 400px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
    color: #5d5d5d;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    h2 {
      text-align: center;
      margin-bottom: 30px;
      font-size: 28px;
    }
    .el-radio-group {
      width: 100%;
    }
    .el-radio-button {
      width: 50%;
    }
    .el-radio-button__inner {
      width: 100%;
    }
    .border-setyle {
      border: 1px solid #c9cacc;
      background: #fff;
      border-radius: 4px;
      .el-input__inner {
        border: 0;
      }
      .el-form-item__label {
        font-size: 16px;
      }
    }
    .register-btn {
      font-size: #999;
      margin-left: 28px;
      font-size: 12px;
    }
  }
  .foot-style {
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 20px 0;
    .foot-cont {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      font-size: 12px;
      line-height: 30px;
      span{
        margin-right: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue